// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".office-layout[data-v-810f9936]{margin-top:7px;display:grid;grid-template-columns:300px 418px;grid-column-gap:2rem;grid-row-gap:2rem;padding-bottom:80px}@media (min-width:1200px){.office-layout[data-v-810f9936]{grid-template-columns:340px 800px;grid-column-gap:3rem;grid-row-gap:3rem}}", ""]);
// Exports
module.exports = exports;
